import IResult from 'src/dataModel/IResult';
import IReq from './IReq';
import IResp from './IResp';
import Urls from 'src/config/Urls';
import http from 'src/utils/ajaxUtils';

/**
 * 接口描述
 * @param param 参数，IReq类型
 */
async function delEducateAchievement(id: number, param: IReq): Promise<IResult<IResp>> {
  const resp = await http.delete(Urls.delEducateAchievement.replace('{id}', id.toString()), param);
  return resp;
}

export default delEducateAchievement;


// WEBPACK FOOTER //
// ./src/api/progress/delEducateAchievement/index.ts